import Enum from "../../../../class/Enum"

export default Enum.make(["MISSING_UBO", "WRONG_UBO_INFORMATION", "UBO_IDENTITY_NEEDED", "SHAREHOLDERS_DECLARATION_NEEDED", "ORGANIZATION_CHART_NEEDED", "DOCUMENTS_NEEDED", "DECLARATION_DO_NOT_MATCH_UBO_INFORMATION", "SPECIFIC_CASE"]);
